import {Icon, icon, IconOptions} from 'leaflet';

export class MapConstants {
  public static IconOptions: IconOptions = {
    iconUrl: 'assets/icons/map/ic_map_pin_default.svg',
    iconRetinaUrl: 'assets/icons/map/ic_map_pin_default.svg',
    iconSize: [42, 50],
    iconAnchor: [21, 50],
    popupAnchor: [0, -50],
    shadowUrl: undefined,
  }

  public static DefaultMapIcon: Icon = icon({
    ...MapConstants.IconOptions,
  });
}
